<template>
  <div class="first-section">
    <div class="content">
      <div class="about-section">
        <h1>WHO WE ARE</h1>
        <H3
          >Our startup hedge fund is currently in the process of building a
          robust investment platform to revolutionize the way investors approach
          the financial markets. While we haven't officially launched yet, our
          team of seasoned professionals is diligently working to establish a
          solid foundation and develop innovative investment strategies. We are
          driven by a commitment to deliver exceptional returns, backed by
          thorough research and rigorous risk management. Stay tuned as we
          prepare to launch our hedge fund and embark on a journey to redefine
          investment opportunities and drive long-term success for our
          clients.</H3
        >
      </div>
      <div class="team-section">
        <h1>The Team</h1>
        <h3>Mariah K</h3>
        <h3>Simon S</h3>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.first-section {
  width: 100vw;
  height: 100vh;
  display: flex;
  padding-top: 15vh;

  justify-content: center;

  .content {
    width: 80%;
    flex-wrap: wrap;
    // text-align: center;

    .team-section {
      margin-top: 80px;
    }

    h1 {
      font-size: 5vw;
    }

    h3 {
      font-family: helvetica;
      color: white;
      line-height: 1.5;
      font-size: 20px;
      font-weight: 100;
      text-align: justify;
    }

    .team-section {
    }
  }
}
</style>
